import * as auth from './auth';
import * as buttons from './buttons';
import * as common from './common';
import * as emailer from './emailer';
import * as fields from './fields';
import * as icons from './icons';
import * as layout from './layout';
import * as navigation from './navigation';
import * as service from './service';
import * as utilities from './utils';

export const loadedNameSpaces = {
  common,
  buttons,
  auth,
  fields,
  service,
  icons,
  navigation,
  emailer,
  layout,
  utils: utilities,
  // .... add your modules
};
